
import Vue, {PropOptions} from 'vue'
import {ChefReviewInterface} from '~/store/chef'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default Vue.extend({
  name: 'ChefReviewCard',
  props: {
    review: {
      type: Object,
      required: true
    } as PropOptions<ChefReviewInterface>
  },
  computed: {
    lightBoxImages(): string[] {
      return this.review.images.map(image => {
        return image.url
      })
    },
  },
  data(): {
    lightBoxIndex: number | null;
  } {
    return {
      lightBoxIndex: null,
    }
  },
})
